import React, { useEffect, useRef, useState } from 'react'
import { template1PreviewData } from '../../lib/TemplatesData';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { FaArrowUpRightFromSquare, FaLocationDot } from 'react-icons/fa6';
import { ensureUrlProtocol } from '../../lib/util';
import arrowUpIcon from '../../assets/arrowUpIcon.svg'

const Template3 = () => {

    const iconStyle = { fontSize: '15px', marginTop: '3px', marginRight: '3px', color: '#0284c7' };
    let formData = localStorage.getItem("formData");
    formData = formData !== null ? JSON.parse(formData) : template1PreviewData;
    const { firstName = '', lastName = '', summary = '', email = '', phone = '', country = '', links = [], Experience = [], Education = [], Skills = [], Projects = [] } = formData;
  let A4_HEIGHT_PX = (297 / 25.4) * 96 ;
  const [templateHeight,setTemplateheight] = useState(A4_HEIGHT_PX )
        const contentRef = useRef();

      

    
   useEffect(() => {
          const element = contentRef.current;
  
          if (!element) return;
  
          const resizeObserver = new ResizeObserver((entries) => {
            if(element?.offsetHeight > templateHeight){
                setTemplateheight((prev)=> prev + templateHeight)
            }
          });
  
          resizeObserver.observe(element);
  
          // Cleanup the observer on component unmount
          return () => {
              resizeObserver.disconnect();
          };
    // eslint-disable-next-line
      }, [])
    return (
        <div ref={contentRef}>
            {/* Left Section */}
            <div className='absolute -z-20 bg-sky-600 w-1/4' style={{height: templateHeight}}>

            </div>
            <div className='py-8'>
                {/* Header */}
                <div className='w-full bg-white px-10 py-5'>
                    <h1 className='text-5xl font-semibold'>{firstName} {lastName}</h1>
                    <div className='flex flex-wrap gap-x-5 gap-y-3 pt-4'>
                        {email !== '' && <div className='flex items-center '><FaEnvelope style={iconStyle} /> <a href={`mailto:${email}`} className='underline underline-offset-4 text-sm'>{email}</a></div>}
                        {phone !== '' && <div className='flex items-center '><FaPhoneAlt style={iconStyle} /> <span className='underline underline-offset-4 text-sm' >{phone}</span></div>}
                        {country !== '' && <div className='flex items-center '><FaLocationDot style={{ ...iconStyle, fontSize: '17px' }} /> <span className='underline underline-offset-4 text-sm' >{country}</span></div>}
                        {links.length > 0 && links.map((item, index) => {
                            const { label = '', link = '' } = item;
                            const formattedLink = ensureUrlProtocol(link)
                            const domain = link.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
                            return label !== '' && <div key={index} className='flex items-center '>
                                {link !== '' && <img
                                    src={`https://img.logo.dev/name/${domain}?token=pk_epQ-03M2S36qD6zus6lrXQ`}
                                    alt={``}
                                    width="17"
                                    height="17"
                                    style={iconStyle}
                                    onError={(e) => {
                                        e.currentTarget.onerror = null; // Prevents infinite loop if fallback also fails
                                        e.currentTarget.src = arrowUpIcon;
                                        e.currentTarget.width = '15'
                                        e.currentTarget.height = '15'
                                    }}
                                />}
                                <a href={formattedLink} target='_blank' rel="noreferrer" className='underline underline-offset-4 text-sm'>{label} </a> </div>
                        })}

                    </div>

                </div>
                <hr className="border-black w-[95%] mx-auto bg-black border "></hr>
                {/* Summary */}
                {summary !== '' && <div className='pt-2 flex'>
                    <h1 className='w-1/4 text-center text-lg font-bold text-black'>SUMMARY</h1>
                    <div className='w-3/4'> <div
                        dangerouslySetInnerHTML={{ __html: summary }}
                        className='project-list'
                    /></div>
                    
                </div>}
               { summary !== '' && <hr className="border-black w-[95%] mx-auto bg-black border "></hr>}

                {/* Work Experience */}
                {Experience.length > 0 && <div className='flex w-full py-2'>
                    <h1 className='w-1/4 text-center text-lg font-bold text-black'>WORK EXPERIENCE</h1>

                    {/* <div className='w-full h-[1.5px] bg-black'></div> */}
                    <div className='w-3/4 pl-5 pr-5 flex flex-col'>
                        {Experience.map((item, index) => {
                            const { employer = '', jobTitle = '', desc = '', startDate = '', endDate = '' } = item;
                            return <div key={index}>
                                <div className='flex justify-between'>
                                    <span className='text-base font-semibold'>{employer}</span>
                                    {/* <span className='text-sm font-semibold'>{startDate}-{endDate}</span> */}
                                </div>
                                <div className='flex justify-between items-center'>
                                    <span className='italic underline underline-offset-4 font-medium'>{jobTitle}</span>
                                    <span className='text-xs font-semibold'>{startDate}-{endDate}</span>
                                    {/* <span className='text-sm font-medium'>{city}</span> */}
                                </div>
                                <div
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                    className='exp-list'
                                />
                            </div>
                        })}
                    </div>


                </div>}

               {Experience.length > 0 &&  <hr className="border-black w-[95%] mx-auto bg-black border dark:bg-gray-700"></hr>}


                {Education.length > 0 && <div className='flex w-full py-2'>
                    <h1 className='w-1/4 text-center text-lg font-bold text-black'>EDUCATION</h1>

                    {/* <div className='w-full h-[1.5px] bg-black'></div> */}
                    <div className='w-3/4 pl-5 pr-5 flex flex-col'>
                        {Education.map((item, index) => {
                            const { degree = '', college = '', city = '', desc = '', startDate = '', endDate = '' } = item;
                            return <div key={index}>
                                <div className='flex justify-between items-center'>
                                    <span className='text-base font-semibold'>{college}</span>
                                    <span className='text-sm font-semibold'>{city}</span>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <span className='text-sm font-normal'>{degree}</span>
                                    <span className='text-xs font-medium'>{startDate}-{endDate}</span>
                                </div>
                                {desc !== '' && <div
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                    className='exp-list'
                                />}
                            </div>
                        })}
                    </div>


                </div>}

              {  Education.length > 0 &&  <hr className="border-black w-[95%] mx-auto bg-black border dark:bg-gray-700"></hr>}

                {Projects.length > 0 && <div className='flex w-full py-2'>
                    <h1 className='w-1/4 text-center text-lg font-bold text-black'>PROJECT</h1>

                    {/* <div className='w-full h-[1.5px] bg-black'></div> */}
                    <div className='w-3/4 pl-5 pr-5 flex flex-col'>
                        {Projects.map((item, index) => {
                            const { title = '', techStack = '', link = '', desc = '', sourceCode = '' } = item;
                            const formattedLink = ensureUrlProtocol(link)
                            const formattedSourceCodeLink = ensureUrlProtocol(sourceCode)
                            return <div key={index}>
                                <div className='flex w-full items-center justify-between'>
                                    {/* <div className='flex '> */}
                                       <div className='flex'>
                                       <span className='text-sm font-semibold underline underline-offset-2'>{title} </span>
                                       {link !== '' && <a className='ml-1' href={formattedLink} target='_blank' rel="noreferrer"> <FaArrowUpRightFromSquare style={iconStyle} /> </a>}
                                       </div>
                                        {/* <span className='mx-1'>|</span> */}
                                        {/* {sourceCode !== '' && <span className='mx-1'>|</span>} */}
                                        {sourceCode !== '' && <a href={formattedSourceCodeLink} target='_blank' rel="noreferrer" className='cursor-pointer flex items-center text-xs font-medium underline underline-offset-4'> <span>source code</span>  <FaArrowUpRightFromSquare className='ml-1' style={{ fontSize: '10px', marginTop: '2px' }} /></a>}

                                    {/* </div> */}
                                </div>
                                <span className='text-xs font-normal underline underline-offset-4'>Tech Stack: {techStack}</span>

                                {desc !== '' && <div
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                    className='project-list'
                                />}
                            </div>
                        })}
                    </div>


                </div>}

               {Projects.length > 0 && <hr className="border-black w-[95%] mx-auto bg-black border dark:bg-gray-700"></hr>}

                {Skills.length > 0 && <div className='flex w-full py-2'>
                    <h1 className='w-1/4 text-center text-lg font-bold text-black'>SKILLS</h1>

                    {/* <div className='w-full h-[1.5px] bg-black'></div> */}
                    <div className='w-3/4 pl-5 pr-5 flex flex-col'>
                    <div className='skill-list'>
                    <ul className="grid-list template-3-grid">
                        {Skills.map((item, index) => {
                            const { skill = '' } = item;
                            return <li key={index}>{skill}</li>;
                        })}
                    </ul>
                </div>
                    </div>


                </div>}
            </div>



            {/* Right Section */}
            {/* <div></div> */}
        </div>
    )
}

export default Template3